import { EMAIL_INFO_PF, REGEX_EMAIL } from "./Constants";

/* validación de correo electronico */
export const emailValidate = (value) =>
    !REGEX_EMAIL.test(value) ? "Correo invalido" : false;

export const emailSupportPf = value => (value.toLowerCase() === EMAIL_INFO_PF ? "Correo invalido" : false);

export const passwordValidate = (value) => {
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialCharacter = /[$@#&!]/.test(value);

    const isValidForm = value.length >= 8 && hasUpperCase && hasLowerCase && hasNumber && hasSpecialCharacter;

    if (!isValidForm) return "invalid_password";
};

//validación de nombre completo
export const fullnameSpaces = (value) => {
    const countSpaces = value.trim().split(" ").length - 1;
    return countSpaces >= 1 && countSpaces <= 3 ? undefined : "Nombre invalido";
};


export const maxLength = (max) => (value) =>
    value && value.length > max ? "validate_characters_max" : undefined;

export const maxLength6 = maxLength(6);
export const maxLength12 = maxLength(12);